.editor {
	position: relative;
	width: 100%;
	height: 100%;
	overflow: hidden;
	z-index: 1;
	background-color: var(--tl-color-background);
}
